// if (!customElements.get('product-form')) {
//   customElements.define(
//     'product-form',
//     class ProductForm extends HTMLElement {
//       constructor() {
//         super();

//         this.form = this.querySelector('form');
//         this.form.querySelector('[name=id]').disabled = false;
//         this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
//         this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
//         this.submitButton = this.querySelector('[type="submit"]');

//         if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

//         this.hideErrors = this.dataset.hideErrors === 'true';
//       }

//       onSubmitHandler(evt) {
//         evt.preventDefault();
//         if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

//         this.handleErrorMessage();

//         this.submitButton.setAttribute('aria-disabled', true);
//         this.submitButton.classList.add('loading');
//         this.querySelector('.loading__spinner').classList.remove('hidden');

//         const config = fetchConfig('javascript');
//         config.headers['X-Requested-With'] = 'XMLHttpRequest';
//         delete config.headers['Content-Type'];

//         const formData = new FormData(this.form);
//         if (this.cart) {
//           formData.append(
//             'sections',
//             this.cart.getSectionsToRender().map((section) => section.id)
//           );
//           formData.append('sections_url', window.location.pathname);
//           this.cart.setActiveElement(document.activeElement);
//         }
//         config.body = formData;

//         fetch(`${routes.cart_add_url}`, config)
//           .then((response) => response.json())
//           .then((response) => {
//             if (response.status) {
//               publish(PUB_SUB_EVENTS.cartError, {
//                 source: 'product-form',
//                 productVariantId: formData.get('id'),
//                 errors: response.errors || response.description,
//                 message: response.message,
//               });
//               this.handleErrorMessage(response.description);

//               const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
//               if (!soldOutMessage) return;
//               this.submitButton.setAttribute('aria-disabled', true);
//               this.submitButton.querySelector('span').classList.add('hidden');
//               soldOutMessage.classList.remove('hidden');
//               this.error = true;
//               return;
//             } else if (!this.cart) {
//               window.location = window.routes.cart_url;
//               return;
//             }

//             if (!this.error)
//               publish(PUB_SUB_EVENTS.cartUpdate, {
//                 source: 'product-form',
//                 productVariantId: formData.get('id'),
//                 cartData: response,
//               });
//             this.error = false;
//             const quickAddModal = this.closest('quick-add-modal');
//             if (quickAddModal) {
//               document.body.addEventListener(
//                 'modalClosed',
//                 () => {
//                   setTimeout(() => {
//                     this.cart.renderContents(response);
//                   });
//                 },
//                 { once: true }
//               );
//               quickAddModal.hide(true);
//             } else {
//               this.cart.renderContents(response);
//             }
//           })
//           .catch((e) => {
//             console.error(e);
//           })
//           .finally(() => {
//             this.submitButton.classList.remove('loading');
//             if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
//             if (!this.error) this.submitButton.removeAttribute('aria-disabled');
//             this.querySelector('.loading__spinner').classList.add('hidden');
//           });
//       }

//       handleErrorMessage(errorMessage = false) {
//         if (this.hideErrors) return;

//         this.errorMessageWrapper =
//           this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
//         if (!this.errorMessageWrapper) return;
//         this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

//         this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

//         if (errorMessage) {
//           this.errorMessage.textContent = errorMessage;
//         }
//       }
//     }
//   );
// }
if (!customElements.get('product-form')) {
  customElements.define('product-form', class ProductForm extends HTMLElement {
    constructor() {
      super();

      this.form = this.querySelector('form');
      if (this.form.querySelector('[name=id]') != null) {
        this.form.querySelector('[name=id]').disabled = false;
      }

      this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
      this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
      this.submitButton = this.querySelector('[type="submit"]');
      if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');
    }
    checkGiftWithPurchase() {
      if (!window.CartGiftWithPurchase) {
        return false;
      }
  
      fetch(`${routes.cart_url}`, {
        ...fetchConfig()
      })
        .then((response) => response.json())
        .then(async (cart) => {
          await window.CartGiftWithPurchase.manageGiftWithPurchase(cart);
        });
    }


    onSubmitHandler(evt) {
      evt.preventDefault();
      if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

      this.handleErrorMessage();

      this.submitButton.setAttribute('aria-disabled', true);
      this.submitButton.classList.add('loading');
      this.querySelector('.loading-overlay__spinner').classList.remove('hidden');

      const config = fetchConfig('javascript');
      config.headers['X-Requested-With'] = 'XMLHttpRequest';
      delete config.headers['Content-Type'];

      //  console.log(this.cart);

      const formData = new FormData(this.form);
      console.log(this.cart.getSectionsToRender().map((section) => section.id));
      if (this.cart) {
        formData.append('sections', this.cart.getSectionsToRender().map((section) => section.id));
        formData.append('sections_url', window.location.pathname);
        this.cart.setActiveElement(document.activeElement);
      }


      //custom add to cart start
      //  console.log(this.classList.contains('product-options'));
      //  let templateProductOtion = document.body.classList.contains('product-options');
      let templateProductOtion = this.classList.contains('product-options');
      //  console.log(templateProductOtion);
      if (templateProductOtion) {
        var leftBC = ''; if (document.querySelector('#left_bc') != null) { leftBC = document.querySelector('#left_bc').value };
        var left_dia = ''; if (document.querySelector('#left_dia') != null) { left_dia = document.querySelector('#left_dia').value };
        var left_axis = ''; if (document.querySelector('#left_axis') != null) { left_axis = document.querySelector('#left_axis').value };
        var left_color = ''; if (document.querySelector('#left_color') != null) { left_color = document.querySelector('#left_color').value };
        var left_cyl = ''; if (document.querySelector('#left_cyl') != null) { left_cyl = document.querySelector('#left_cyl').value };
        var left_add = ''; if (document.querySelector('#left_add') != null) { left_add = document.querySelector('#left_add').value };
        var right_bc = ''; if (document.querySelector('#right_bc') != null) { right_bc = document.querySelector('#right_bc').value };
        var right_dia = ''; if (document.querySelector('#right_dia') != null) { right_dia = document.querySelector('#right_dia').value };
        var right_axis = ''; if (document.querySelector('#right_axis') != null) { right_axis = document.querySelector('#right_axis').value };
        var right_color = ''; if (document.querySelector('#right_color') != null) { right_color = document.querySelector('#right_color').value };
        var right_cyl = ''; if (document.querySelector('#right_cyl') != null) { right_cyl = document.querySelector('#right_cyl').value };
        var right_add = ''; if (document.querySelector('#right_add') != null) { right_add = document.querySelector('#right_add').value };
        let bundle_formData = '';

        var allfiledfillup = false;

        var count = 0;
        [...document.querySelectorAll('.leftbox.active .product-form__input select')].forEach(el => {
          console.log(el.value);
          if (el.value == '') {
            allfiledfillup = false;
            el.classList.add("error-option");
          } else {
            count = count + 1;
            allfiledfillup = true;
            el.classList.remove("error-option");
          }
        });
        [...document.querySelectorAll('.rightbox.active .product-form__input select')].forEach(el => {
          // console.log(el.value);
          if (el.value == '') {
            allfiledfillup = false;
            el.classList.add("error-option");
          } else {
            count = count + 1;
            allfiledfillup = true;
            el.classList.remove("error-option");
          }
        });

        var selectorCount = [...document.querySelectorAll('.leftbox.active .product-form__input select')].length + [...document.querySelectorAll('.rightbox.active .product-form__input select')].length;
        // console.log( [...document.querySelectorAll('.leftbox.active .product-form__input select')].length +  [...document.querySelectorAll('.rightbox.active .product-form__input select')].length);
        // console.log(count);
        if (selectorCount == count) {
          if (document.querySelector('#leftbox').classList.contains('active') && document.querySelector('#rightbox').classList.contains('active') == false) {
            // console.log('if');
            // console.log(document.querySelector('#left_add'));
            bundle_formData = {
              items: [
                {
                  id: document.querySelector('.left_side_input').value,
                  quantity: document.querySelector('.left-qty .quantity__input').value,
                  properties: {
                    // 'Eye':'Left (OS)',
                    // 'Power': document.querySelector('.left_side_input').getAttribute('var_name'), 
                    // 'Base Curve (BC)': leftBC, //left_bc
                    // 'Diameter (DIA)': left_dia, //left_dia,
                    // 'Cylinder (CYL)': left_cyl, //left_cyl
                    // 'Axis': left_axis, //left_axis
                    // 'Colored lenses': left_color, //left_colorValue                 
                    // 'Add':left_add, //left_add
                  }
                }
              ],
              sections: ['cart-drawer', 'cart-icon-bubble']
            };
            bundle_formData.items[0].properties[Eye] = 'Left (OS)';
            bundle_formData.items[0].properties[Power] = document.querySelector('.left_side_input').getAttribute('var_name');
            bundle_formData.items[0].properties[BaseCurve_BC] = leftBC;
            bundle_formData.items[0].properties[Diameter_DIA] = left_dia;
            bundle_formData.items[0].properties[Cylinder_CYL] = left_cyl;
            bundle_formData.items[0].properties[Axis] = left_axis;
            bundle_formData.items[0].properties[Colored_lenses] = left_color;
            bundle_formData.items[0].properties[Add] = left_add;
          } else if (document.querySelector('#rightbox').classList.contains('active') && document.querySelector('#leftbox').classList.contains('active') == false) {
            console.log('else if');
            // console.log(document.querySelector('#right_add'));
            bundle_formData = {
              items: [
                {
                  id: document.querySelector('.right_side_input').value,
                  quantity: document.querySelector('.right-qty .quantity__input').value,
                  properties: {
                    // 'Eye': 'Right (OD)',
                    // 'Power': document.querySelector('.right_side_input').getAttribute('var_name'), 
                    // 'Base Curve (BC)': right_bc, //right_bc
                    // 'Diameter (DIA)': right_dia, //right_dia,
                    // 'Cylinder (CYL)': right_cyl, //right_cyl
                    // 'Axis': right_axis, //right_axis
                    // 'Colored lenses': right_color, //right_colorValue                  
                    // 'Add': right_add, //right_add
                  }
                }
              ],
              sections: ['cart-drawer', 'cart-icon-bubble']
            };
            bundle_formData.items[0].properties[Eye] = 'Right (OD)';
            bundle_formData.items[0].properties[Power] = document.querySelector('.right_side_input').getAttribute('var_name');
            bundle_formData.items[0].properties[BaseCurve_BC] = right_bc;
            bundle_formData.items[0].properties[Diameter_DIA] = right_dia;
            bundle_formData.items[0].properties[Cylinder_CYL] = right_cyl;
            bundle_formData.items[0].properties[Axis] = right_axis;
            bundle_formData.items[0].properties[Colored_lenses] = right_color;
            bundle_formData.items[0].properties[Add] = right_add;
          } else {
            console.log('else');

            // console.log('leftBC = '+leftBC);
            // console.log('left_dia = '+left_dia);
            // console.log('left_axis = '+leftBC);
            // console.log('left_color = '+left_color);
            // console.log('left_cyl = '+left_cyl);
            // console.log('left_add = '+left_add);

            bundle_formData = {
              items: [
                {
                  id: document.querySelector('.left_side_input').value,
                  quantity: document.querySelector('.left-qty .quantity__input').value,
                  properties: {
                    // 'Eye':'Left (OS)',
                    // 'Power': document.querySelector('.left_side_input').getAttribute('var_name'), 
                    // 'Base Curve (BC)': leftBC, //left_bc
                    // 'Diameter (DIA)': left_dia, //left_dia,
                    // 'Cylinder (CYL)': left_cyl, //left_cyl
                    // 'Axis': left_axis, //left_axis
                    // 'Colored lenses': left_color, //left_colorValue                  
                    // 'Add':left_add, //left_add
                  }
                },
                {
                  id: document.querySelector('.right_side_input').value,
                  quantity: document.querySelector('.right-qty .quantity__input').value,
                  properties: {
                    // 'Eye': 'Right (OD)',
                    // 'Power': document.querySelector('.right_side_input').getAttribute('var_name'), 
                    // 'Base Curve (BC)': right_bc, //right_bc
                    // 'Diameter (DIA)': right_dia, //right_dia,                  
                    // 'Cylinder (CYL)': right_cyl, //right_cyl
                    // 'Axis': right_axis, //right_axis
                    // 'Colored lenses': right_color, //right_colorValue
                    // 'Add': right_add, //right_add
                  }
                }
              ],
              sections: ['cart-drawer', 'cart-icon-bubble']
            };

            bundle_formData.items[0].properties[Eye] = 'Left (OS)';
            bundle_formData.items[0].properties[Power] = document.querySelector('.left_side_input').getAttribute('var_name');
            bundle_formData.items[0].properties[BaseCurve_BC] = leftBC;
            bundle_formData.items[0].properties[Diameter_DIA] = left_dia;
            bundle_formData.items[0].properties[Cylinder_CYL] = left_cyl;
            bundle_formData.items[0].properties[Axis] = left_axis;
            bundle_formData.items[0].properties[Colored_lenses] = left_color;
            bundle_formData.items[0].properties[Add] = left_add;

            bundle_formData.items[1].properties[Eye] = 'Right (OD)';
            bundle_formData.items[1].properties[Power] = document.querySelector('.right_side_input').getAttribute('var_name');
            bundle_formData.items[1].properties[BaseCurve_BC] = right_bc;
            bundle_formData.items[1].properties[Diameter_DIA] = right_dia;
            bundle_formData.items[1].properties[Cylinder_CYL] = right_cyl;
            bundle_formData.items[1].properties[Axis] = right_axis;
            bundle_formData.items[1].properties[Colored_lenses] = right_color;
            bundle_formData.items[1].properties[Add] = right_add;

          }
        }
        console.log(bundle_formData);

        console.log('Eye - ' + Eye + ' | Power - ' + Power + ' | BaseCurve_BC - ' + BaseCurve_BC + ' | Diameter_DIA - ' + Diameter_DIA);



        let thisOriginal = this;
        var hasPower = this.validatePower();
        debugger;

        if(hasPower) {
          fetch(window.Shopify.routes.root + 'cart/add.js', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json'
            },
            body: JSON.stringify(bundle_formData)
          })
          .then(function (response) {
            return response.json();
          })
          .then(function (response) {
            console.log(response);
            if (response.status) {
              console.log('if response status');
              this.handleErrorMessage(response.description);
              const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
              if (!soldOutMessage) return;
              this.submitButton.setAttribute('aria-disabled', true);
              this.submitButton.querySelector('span').classList.add('hidden');
              soldOutMessage.classList.remove('hidden');
              this.error = true;
              return;
            } else if (!thisOriginal.cart) {
              console.log('else if not!this cart');
              window.location = window.routes.cart_url;
              return;
            }
            thisOriginal.error = false;
            const quickAddModal = thisOriginal.closest('quick-add-modal');
            if (quickAddModal) {
              document.body.addEventListener('modalClosed', () => {
                setTimeout(() => { thisOriginal.cart.renderContents(response); thisOriginal.checkGiftWithPurchase(); });
              }, { once: true });
              quickAddModal.hide(true);
            } else {
              thisOriginal.cart.renderContents(response);
              thisOriginal.checkGiftWithPurchase();
            }
            document.querySelector('.option_error').innerHTML = "";
          })
          .catch((error) => {
            console.log('please check options');
            if (document.querySelector('.right_option_0').value == 'select-option') {
              document.querySelector('.right_option_0').classList.add("error-option");
            } else {
              document.querySelector('.right_option_0').classList.remove("error-option");
            }
            if (document.querySelector('.left_option_0').value == 'select-option') {
              document.querySelector('.left_option_0').classList.add("error-option");
            } else {
              document.querySelector('.left_option_0').classList.remove("error-option");
            }
            document.querySelector('.option_error').innerHTML = "Please check options";
            console.error('Error:', error);
          })
          .finally(() => {
            this.submitButton.classList.remove('loading');
            if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
            if (!this.error) this.submitButton.removeAttribute('aria-disabled');
            this.querySelector('.loading-overlay__spinner').classList.add('hidden');
          });
        } else {
          console.log('please check options');
          if (document.querySelector('.right_option_0').value == 'select-option') {
            document.querySelector('.right_option_0').classList.add("error-option");
          } else {
            document.querySelector('.right_option_0').classList.remove("error-option");
          }
          if (document.querySelector('.left_option_0').value == 'select-option') {
            document.querySelector('.left_option_0').classList.add("error-option");
          } else {
            document.querySelector('.left_option_0').classList.remove("error-option");
          }
          document.querySelector('.option_error').innerHTML = "Please check options";
          this.submitButton.classList.remove('loading');
          this.querySelector('.loading-overlay__spinner').classList.add('hidden');
          this.submitButton.removeAttribute('aria-disabled')
        }
        


        //custom add to cart end
      } else {
        console.log('else');
        //Orginal add to cart code start
        config.body = formData;
        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              this.handleErrorMessage(response.description);
              const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
              if (!soldOutMessage) return;
              this.submitButton.setAttribute('aria-disabled', true);
              this.submitButton.querySelector('span').classList.add('hidden');
              soldOutMessage.classList.remove('hidden');
              this.error = true;
              return;
            } else if (!this.cart) {
              window.location = window.routes.cart_url;
              return;
            }
            this.error = false;
            const quickAddModal = this.closest('quick-add-modal');
            if (quickAddModal) {
              document.body.addEventListener('modalClosed', () => {
                setTimeout(() => { this.cart.renderContents(response); this.checkGiftWithPurchase(); });
              }, { once: true });
              quickAddModal.hide(true);
            } else {
              this.cart.renderContents(response);
              this.checkGiftWithPurchase();
            }
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            this.submitButton.classList.remove('loading');
            if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
            if (!this.error) this.submitButton.removeAttribute('aria-disabled');
            this.querySelector('.loading-overlay__spinner').classList.add('hidden');
          });
        //Orginal add to cart code end
      }


    }

    handleErrorMessage(errorMessage = false) {
      this.errorMessageWrapper = this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
      if (!this.errorMessageWrapper) return;
      this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

      this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

      if (errorMessage) {
        this.errorMessage.textContent = errorMessage;
      }
    }
    /**
     * @returns {Boolean}
     */
    validatePower() {
      /**
       * @type {Array<HTMLSelectElement>}
       */
      var powerNodes = [...this.querySelectorAll('.option_power')] || [];
      powerNodes = powerNodes.filter(node => !!node.closest('.leftright-box.active'));
      if (powerNodes.length === 0) return true;
      if (powerNodes.length && powerNodes.every(powerNode => !powerNode?.value?.includes('select-option'))) return true;
      return false;
    }
  });
}
